<template>
	<router-view v-if="isRouterAlive"></router-view>
	<!-- <block></block> -->
</template>

<script>
	export default {
		name: 'app',
		// 注入reload函数属性
		provide() {
			return {
				reload: this.reload
			}
		},
		data() {
			return {
				isRouterAlive: true
			}
		},
		methods: {
			// 页面全局刷新方法
			reload() {
				this.isRouterAlive = false
				this.$nextTick(() => {
					this.isRouterAlive = true
				})
			}
		}
	}
</script>

<style>
	@import url("//at.alicdn.com/t/font_2280498_70tbqvmmo99.css");

	.hover:hover {
		cursor: pointer;
	}

	.flex {
		display: flex;
	}

	.cflex {
		display: flex;
		flex-direction: column;
	}

	.wrap {
		flex-wrap: wrap;
	}

	.around {
		justify-content: space-around;
	}

	.between {
		justify-content: space-between;
	}

	.w100 {
		width: 100%;
		margin: 0 auto;
	}

	.w90 {
		width: 90%;
		margin: 0 auto;
	}

	.w80 {
		width: 80%;
		margin: 0 auto;
	}

	.w70 {
		width: 70%;
		margin: 0 auto;
	}

	.w60 {
		width: 60%;
		margin: 0 auto;
	}

	.w50 {
		width: 50%;
		margin: 0 auto;
	}

	.w40 {
		width: 40%;
		margin: 0 auto;
	}

	.w30 {
		width: 30%;
		margin: 0 auto;
	}

	.w20 {
		width: 20%;
		margin: 0 auto;
	}

	.w10 {
		width: 10%;
		margin: 0 auto;
	}

	.h10 {
		height: 10px;
	}

	.h20 {
		height: 20px;
	}

	.h30 {
		height: 30px;
	}

	.h40 {
		height: 40px;
	}

	.h50 {
		height: 50px;
	}

	.h60 {
		height: 60px;
	}

	.h70 {
		height: 70px;
	}

	.h80 {
		height: 80px;
	}

	.h90 {
		height: 90px;
	}

	.h100 {
		height: 100px;
	}

	.text_left {
		text-align: left;
	}

	.text_center {
		text-align: center;
	}

	.text_right {
		text-align: right;
	}

	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
	}

	input[type="number"] {
		-moz-appearance: textfield;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue